export default "__VITE_ASSET__RvqG$BLP__"